import http from '@/services/http';

//-------------------- GETS ----------------------

export async function getWholesalers(filter) {
  try {
    let res = await http.get('/Wholesaler');
    if (filter) {
      return res.data.data.filter(item => item[filter]);
    } else {
      return res.data.data;
    }
  } catch (e) {
    console.log(e);
  }
}

//-------------------- PUTS ----------------------

export async function updateWholesaler(id, data) {
  try {
    const res = await http.put(`/Wholesaler/${id}`, data);
    return res;
  } catch (e) {
    console.log(e);
  }
}

//-------------------- POSTS ----------------------

export async function createNewWholesaler(data) {
  try {
    const res = await http.post('Wholesaler', data);
    return res;
  } catch (e) {
    console.log(e);
  }
}
